import styled from "styled-components";
import Heading from "../../heading/Heading";

export const ContributionFormHeading = styled(Heading)`
  font-size: var(--heading-level4-size);
  line-height: var(--heading-level4-lineHeight);
  color: #000;
  font-weight: 600;
`;
ContributionFormHeading.defaultProps = {
  level: "2"
};
